import { Loader2, Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { RadioGroup } from "@/components/ui/radio-group";

import type { ApiKey } from "./ApiKeyItem";
import { ApiKeyItem } from "./ApiKeyItem";

interface ApiKeysSectionProps {
  apiKeys: ApiKey[];
  onSelect: (id: string) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  onAdd: () => void;
  isLoading?: boolean;
  isDeleting?: boolean;
}

export const ApiKeysSection = ({
  apiKeys,
  onSelect,
  onEdit,
  onDelete,
  onAdd,
  isLoading,
  isDeleting,
}: ApiKeysSectionProps) => {
  const activeId = apiKeys.find((key) => key.isActive)?.id ?? "";

  return (
    <div className="flex flex-col gap-2">
      <h2 className="fs-300 font-semibold text-neutral-100">API-ключи биржи</h2>

      <div className="flex flex-col gap-4">
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="size-6 animate-spin text-neutral-500" />
          </div>
        ) : apiKeys.length === 0 ? (
          <p className="fs-300 py-4 text-center text-neutral-400">
            У вас ещё нет подключённых аккаунтов
          </p>
        ) : (
          <RadioGroup
            value={activeId}
            onValueChange={onSelect}
            className="flex flex-col gap-1"
            disabled={isDeleting}
          >
            {apiKeys.map((key) => (
              <ApiKeyItem
                key={key.id}
                apiKey={key}
                onEdit={onEdit}
                onDelete={onDelete}
                disabled={isDeleting}
              />
            ))}
          </RadioGroup>
        )}

        <div className="flex justify-end">
          <Button
            variant="neutral"
            size="sm"
            onClick={onAdd}
            icon={<Plus className="size-5" />}
          >
            Добавить API
          </Button>
        </div>
      </div>
    </div>
  );
};
